import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import axios from "axios";
import { PRODUCTS as STATIC_PRODUCTS } from "@/data/products";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ProductsContext = createContext(null);

export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState(STATIC_PRODUCTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/products`);
      if (Array.isArray(data) && data.length) setProducts(data);
    } catch {
      // keep static catalog
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ products, refresh }), [products, refresh]);
  return <ProductsContext.Provider value={value}>{children}</ProductsContext.Provider>;
};

export const useProducts = () => useContext(ProductsContext);
